import useBreakpoints, { Breakpoint } from "../../hooks/useBreakpoints";

interface ClassroomWelcomeProps {
    title: string;
    subline?: string;
}

export const ClassroomWelcome = (props: ClassroomWelcomeProps) => {
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    const titleSize = getStyleBasedOnBreakpoint(Breakpoint.MD, "text-xxl", "text-xl");
    const sublineSize = getStyleBasedOnBreakpoint(Breakpoint.MD, "text-xl", "text-l");

    return (
        <section className="flex flex-col w-full">
            <h1
                className={`${titleSize} font-semibold text-p6-grey-dark break-words`}
                data-testid="classroom-welcome-title"
            >
                {props.title}
            </h1>
            {props.subline && <p className={`${sublineSize} text-p6-grey-dark break-words`}>{props.subline}</p>}
        </section>
    );
};
